<template>
  <span
    class="tw:flex tw:items-center tw:gap-1"
  >
    <template v-if="inProgress">
      <span
        class="tw:relative tw:flex tw:size-3"
        aria-label="Live animation"
      >
        <span
          class="tw:absolute tw:inline-flex tw:h-full tw:w-full tw:animate-ping tw:rounded-full tw:bg-red-400 tw:opacity-75"
        />
        <span
          class="tw:relative tw:inline-flex tw:size-3 tw:rounded-full tw:bg-red-500"
        />
      </span>
    </template>
    <template v-else>
      <span
        class="tw:inline-flex tw:size-3 tw:rounded-full tw:bg-green-500"
      />
    </template>
  </span>
</template>

<script>
export default {
  name: "TestStatus",
  props: {
    inProgress: {
      type: Boolean,
      default: false,
    },
  }
}
</script>